module.exports = __webpack_public_path__ + "static/media/Yeti.d036bcaa.jpg";